export default function fullBackupReducer(
  state = { error: "", success: "", processing: false },
  action
) {
  switch (action.type) {
    case "FULL_BACKUP_SUCCESS":
      return { ...state, ...{ success: action.success } };

    case "FULL_BACKUP_ERROR":
      return { ...state, ...{ error: action.error } };

    case "FULL_BACKUP_PROCESSING":
      return { ...state, ...{ processing: action.processing } };

    default:
      return state;
  }
}
